import type { SVGProps } from "react";

import * as React from "react";

interface AiIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const Icon = ({
  color = "#9747FF",
  width = 20,
  height = 20,
  ...props
}: AiIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
    viewBox="0 0 20 20"
    width={width}
    height={height}
  >
    <path
      fill={color}
      d="M10.67 16.418c.09.416.683.416.772 0a9.48 9.48 0 0 1 7.28-7.278c.415-.09.415-.683 0-.773a9.48 9.48 0 0 1-7.28-7.279c-.089-.416-.683-.416-.772 0a9.48 9.48 0 0 1-7.279 7.28c-.416.089-.416.682 0 .772a9.48 9.48 0 0 1 7.279 7.278M4.33 18.861c.043.198.326.198.368 0a4.51 4.51 0 0 1 3.466-3.466c.199-.043.199-.325 0-.368a4.51 4.51 0 0 1-3.466-3.466c-.042-.198-.325-.198-.367 0a4.51 4.51 0 0 1-3.467 3.466c-.198.043-.198.325 0 .368a4.51 4.51 0 0 1 3.467 3.466M5.182 5.26c.022.1.163.1.184 0A2.26 2.26 0 0 1 7.1 3.527c.1-.02.1-.162 0-.184A2.26 2.26 0 0 1 5.366 1.61c-.021-.099-.162-.099-.184 0A2.26 2.26 0 0 1 3.45 3.343c-.099.022-.099.163 0 .184A2.26 2.26 0 0 1 5.182 5.26M18.154 6.065c.008.04.065.04.073 0a.9.9 0 0 1 .693-.693c.04-.009.04-.066 0-.074a.9.9 0 0 1-.693-.693c-.008-.04-.065-.04-.073 0a.9.9 0 0 1-.694.693c-.04.008-.04.065 0 .074a.9.9 0 0 1 .694.693"
    />
    <path
      fill={color}
      d="M15.8 5.246c.026.118.196.118.221 0a2.71 2.71 0 0 1 2.08-2.08c.119-.026.119-.195 0-.22a2.71 2.71 0 0 1-2.08-2.08c-.025-.12-.195-.12-.22 0a2.71 2.71 0 0 1-2.08 2.08c-.119.025-.119.194 0 .22a2.71 2.71 0 0 1 2.08 2.08"
    />
  </svg>
);

export default Icon;